import React from "react";
import { Box, CircularProgress } from "@mui/material";

const LoadingPage: React.FC = () => {
  return (
    <Box display="flex" px={{ xs: 2, sm: 4 }} justifyContent="center">
      <Box pt={"300px"} borderRadius={"12px"} overflow={"hidden"}>
        <CircularProgress />
      </Box>
    </Box>
  );
};

export default LoadingPage;
